export default {"src":"/_next/static/media/iso-cert-2.def46116.svg","height":81,"width":134};